import style from './Loader.module.css';

const Loader = () => (
  <div className="loaderWrapper">
    <div className="loaderPage"></div>
  </div>
);

export default Loader;
